import './HxMap.scss'
import { HxKey } from './HxKey'
import { HxNote } from './HxNote'
import { TransformTranslate } from '../../Util/Transform/Transform'
import { ClassNames } from '../../Util/ClassNames'
import { memo } from 'react'
import { HexMap } from '../../Data/HexMap/HexMap'
import { Note } from '../../Data/HexMap/Note'
import { Key } from '../../Data/HexMap/Key'
import { DisplayContext } from './DisplayContext'

export interface HxMapCoreProps{
    hexMap:HexMap
    onKeyClick?:Function
    onNoteClick?:Function
    children?:React.ReactNode
    classNames?:string[]
    ctrl?:boolean
}

function _HxMapGroup(props:HxMapCoreProps){
    
    const onKeyClick = (props.onKeyClick) ? props.onKeyClick : ()=>{}
    const onNoteClick = (props.onNoteClick) ? props.onNoteClick : ()=>{}
    let getKeyComps = () => {
        const keys:Key[] = HexMap.getVisibleKeys(props.hexMap)
        const keyComps:JSX.Element[] = keys.map((key)=>{
            return <HxKey ctrl={props.ctrl} onKeyClick={onKeyClick} key={key.params.keyIndex} keyData={key}/>
        })
        return keyComps
    }
    const getNoteComps = () => {
        const notes:Note[] = HexMap.getVisibleNotes(props.hexMap)
        const noteElms:JSX.Element[] = notes.map((note)=>{
            return <HxNote ctrl={props.ctrl} onNoteClick={onNoteClick} key={note.params.noteIndex} note={note}/>
        })
        return noteElms
    }

    const getClassNames = () => {
        const keys:Key[] = HexMap.getVisibleKeys(props.hexMap)
        let classes:ClassNames = new ClassNames(['hex-map-group'])
        if(props.classNames){classes.addClasses(props.classNames)}
        if(keys.flat().length === 1){classes.addClass('single-key')}
        return classes.toString()
    }
    const getTransform = () => {
        if(props.hexMap.params.centerKey){
            const [row, column] = props.hexMap.params.centerKey
            const key:Key = props.hexMap.keys[row][column]
            return TransformTranslate(key.params.x/-1, key.params.y/-1)
        }
        let [x,y] = props.hexMap.getTransformDimensions()
        return TransformTranslate((x/-2), (y/-2))
    }
    return <g className={getClassNames()} transform={getTransform()}>
                <DisplayContext.Provider value={props.hexMap.params.displayConfig}>
                    {getKeyComps()}
                    {props.children}
                    {getNoteComps()}
                </DisplayContext.Provider>
            </g>
}
export const HxMapGroup = memo(_HxMapGroup)